import { PresetState } from "./PresetState";

export class TblPreset {
  id?: number;
  empId?: number;
  presetData?: PresetState;
  presetName?: string;
  position?: string;

  constructor(
    id?: number,
    empId?: number,
    presetData?: PresetState,
    presetName?: string,
    position?: string
  ) {
    this.id = id;
    this.empId = empId;
    this.presetData = presetData;
    this.presetName = presetName;
    this.position = position;
  }
}
